import React, { useState } from 'react';
import { Card, Col, Row, Button, ButtonGroup } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import Divider from 'components/common/Divider';
import { useNavigate } from 'react-router-dom';
import paths from '../../../routes/paths';

const etats = ['Tous', 'Brouillon', 'Créé', 'Annulé', 'Reçu'];

const AchatHeader = () => {
  const [activeEtat, setActiveEtat] = useState('Tous');
  const navigate = useNavigate();
  return (
    <>
      <Card className="mb-3">
        <Card.Body>
          <Row className="justify-content-between align-items-center">
            <Col md>
              <h5 className="mb-2 mb-md-0">Achats</h5>
            </Col>
            <Col xs="auto">
              <IconButton
                variant="falcon-default"
                size="sm"
                icon="file-export"
                className="me-1 mb-2 mb-sm-0"
                iconClassName="me-1"
              >
                Exporter
              </IconButton>
              <IconButton
                variant="falcon-default"
                size="sm"
                icon="print"
                iconClassName="me-1"
                className="me-1 mb-2 mb-sm-0"
              >
                Imprimer
              </IconButton>
              <IconButton
                variant="primary"
                size="sm"
                icon="file-import"
                className="mb-2 mb-sm-0"
                onClick={() =>
                  navigate(
                    paths.formulaireAchat.replace(
                      ':formulaireAchat',
                      'nouvelAchat'
                    )
                  )
                }
              >
                Ajouter Achat
              </IconButton>
            </Col>
          </Row>
          <Divider />
          <Row>
            <ButtonGroup aria-label="etats-Achat">
              {etats.map((etat, index) => {
                return (
                  <Button
                    key={index}
                    variant={
                      activeEtat === etat ? 'primary' : 'outline-primary'
                    }
                    className="me-2 mb-1 d-inline-block"
                    style={{ flex: 'none' }}
                    onClick={() => setActiveEtat(etat)}
                  >
                    {etat}
                  </Button>
                );
              })}
            </ButtonGroup>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default AchatHeader;
